import { render, staticRenderFns } from "./PartnerReportDetailSendToPdrDialog.vue?vue&type=template&id=e3ba319c&scoped=true&"
import script from "./PartnerReportDetailSendToPdrDialog.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailSendToPdrDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerReportDetailSendToPdrDialog.vue?vue&type=style&index=0&id=e3ba319c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ba319c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VDivider,VSpacer})
